export default __webpack_public_path__ + "static/media/ai_governance_ce_ready.7321e122.svg";